


















































import { defineComponent, reactive, toRefs, computed, ref, onMounted } from '@vue/composition-api';
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";
import { Sheet } from "../../modules/teacher/ResultStudentImageList"


export interface Data {
  sheets: Sheet[]
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context){

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      sheets: [],
      errors: [],
    });

    /******************************
     * 答案PDFダウンロード
     ******************************/

    const downloadImage = async (sheet: Sheet) => {
      context.root.$store.dispatch("showOverlay");
      
      await http.get(`/api/result_student_image_list/download_image/${sheet.id}/${context.root.$store.state.student_num}`, {responseType: 'arraybuffer'}).then(response => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.target = "_blank"
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = JSON.parse(new TextDecoder().decode(error.response.data)).errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * mounted キャッシュしている検索条件で検索実行
     ******************************/
    
    onMounted(async () => {
      if(window.location.href.indexOf("student_site") != -1 && !context.root.$store.state.student_num){
        window.location.href="/#/";
        return;
      }
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/result_student_image_list?student_num=${context.root.$store.state.student_num}&nendo=${context.root.$route.params.nendo}`).then(response => {
        state.sheets = response.data.sheets.map((x: any) => new Sheet(x));
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    });

    return {
      ...toRefs(state),
      downloadImage,
    }
  }
});
